import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, ready } = useAuth();

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">
        Načítání…
      </div>
    );
  }
  if (!user) return <Navigate to="/sprava-9k4x" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "lector" ? "/lector/dashboard" : "/workshops"} replace />;
  }
  return children ? children : <Outlet />;
}
